import SuspensePageLoader from 'components/SuspensePageLoader'
import { Routes } from 'constants/index'
import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Session } from 'types'
import NotFound from '../pages/404'

const Assets = lazy(() => import('pages/assets'))
const Insights = lazy(() => import('pages/insights'))
const Earnings = lazy(() => import('pages/earnings'))
const Payments = lazy(() => import('pages/payments'))
const Submitted = lazy(() => import('pages/submitted'))
const Flagged = lazy(() => import('pages/flagged'))
const Portfolio = lazy(() => import('pages/portfolio'))
const Dashboard = lazy(() => import('pages/dashboard'))
const Profile = lazy(() => import('pages/profile'))
const Tax = lazy(() => import('pages/tax'))
const Referrals = lazy(() => import('pages/referrals'))
const AdminUserRoot = lazy(() => import('pages/admin/users'))
const AdminPendingUsers = lazy(() => import('pages/admin/pending-users'))
const WODashboard = lazy(() => import('pages/wo/dashboard'))
const UtilFrame = lazy(() => import('pages/admin/UtilFrame'))
const Terms = lazy(() => import('pages/terms'))
const ContributorDirectoryInfo = lazy(
  () => import('pages/contributor-directory-info')
)

type Props = {
  session: Session
}

const Router = ({ session }: Props) => {
  let rootRoute = (
    <Route exact path="/">
      <SuspensePageLoader>
        <Dashboard />
      </SuspensePageLoader>
    </Route>
  )

  if (session.wo) {
    rootRoute = (
      <Route exact path="/">
        <SuspensePageLoader>
          <WODashboard />
        </SuspensePageLoader>
      </Route>
    )
  }

  if (session.isAdmin) {
    rootRoute = (
      <Route exact path="/">
        <Redirect to={'/submitted'} />
      </Route>
    )
  }
  return (
    <Switch>
      {/* USER AUTHENTICATED/PROTECTED ROUTES*/}

      <Route exact path={Routes.SignIn}>
        <Redirect to={'/'} />
      </Route>
      <Route path={Routes.Referrals}>
        <SuspensePageLoader>
          <Referrals />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Assets}>
        <SuspensePageLoader>
          <Assets />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Submitted}>
        <SuspensePageLoader>
          <Submitted />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Flagged}>
        <SuspensePageLoader>
          <Flagged />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Insights}>
        <SuspensePageLoader>
          <Insights />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Earnings}>
        <SuspensePageLoader>
          <Earnings />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Payments}>
        <SuspensePageLoader>
          <Payments />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Portfolio}>
        <SuspensePageLoader>
          <Portfolio />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.PortfolioUpload}>
        <SuspensePageLoader>
          <Portfolio />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Profile}>
        <SuspensePageLoader>
          <Profile />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Tax}>
        <SuspensePageLoader>
          <Tax />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.AdminUsers}>
        <SuspensePageLoader>
          <AdminUserRoot />
        </SuspensePageLoader>
      </Route>
      <Route path={`${Routes.Trestle}(.*)`}>
        <SuspensePageLoader>
          <UtilFrame />
        </SuspensePageLoader>
      </Route>
      <Route path={`${Routes.Sidekiq}(.*)`}>
        <SuspensePageLoader>
          <UtilFrame />
        </SuspensePageLoader>
      </Route>
      <Route path={`${Routes.Flipper}(.*)`}>
        <SuspensePageLoader>
          <UtilFrame />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.AdminPendingUsers}>
        <SuspensePageLoader>
          <AdminPendingUsers />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.Terms}>
        <SuspensePageLoader>
          <Terms />
        </SuspensePageLoader>
      </Route>
      <Route path={Routes.ContributorDirectoryInfo}>
        <SuspensePageLoader>
          <ContributorDirectoryInfo />
        </SuspensePageLoader>
      </Route>
      {/* Addtional route setup for marketing purposes */}
      <Route path={Routes.ContributorDirectoryInformation}>
        <SuspensePageLoader>
          <ContributorDirectoryInfo />
        </SuspensePageLoader>
      </Route>

      {rootRoute}
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  )
}

export default Router
